"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duration = exports["default"] = exports.PRIMARY_HAMBURGER_PANEL_ID = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _useAnimationState = require("../../../utils/use-animation-state");
require("./hamburger-nav.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// duration should match animation duration set in CSS
var duration = exports.duration = 300;
var PRIMARY_HAMBURGER_PANEL_ID = exports.PRIMARY_HAMBURGER_PANEL_ID = 'primary-hamburger-nav-panel';
var NavPanel = function NavPanel(_ref) {
  var children = _ref.children,
    _ref$hasNavFooter = _ref.hasNavFooter,
    hasNavFooter = _ref$hasNavFooter === void 0 ? false : _ref$hasNavFooter,
    _ref$isNavPanelOpen = _ref.isNavPanelOpen,
    isNavPanelOpen = _ref$isNavPanelOpen === void 0 ? false : _ref$isNavPanelOpen,
    _ref$isSecondaryNavPa = _ref.isSecondaryNavPanel,
    isSecondaryNavPanel = _ref$isSecondaryNavPa === void 0 ? false : _ref$isSecondaryNavPa,
    _ref$secondaryNavPane = _ref.secondaryNavPanelName,
    secondaryNavPanelName = _ref$secondaryNavPane === void 0 ? '' : _ref$secondaryNavPane,
    returnFocusElement = _ref.returnFocusElement;
  var animationState = (0, _useAnimationState.useAnimationState)(isNavPanelOpen, duration);
  (0, _react.useEffect)(function () {
    // sets focus to the last clicked push view button from the primary nav panel
    if (isSecondaryNavPanel && animationState === _useAnimationState.states.closed && returnFocusElement) {
      returnFocusElement.focus();
    }

    // sets focus on the push view button of the secondary nav panel.
    if (isSecondaryNavPanel && animationState === _useAnimationState.states.open && isNavPanelOpen) {
      var focusTarget = document.getElementById("hamburger-nav-push-view-btn-".concat(secondaryNavPanelName, "-left"));
      if (focusTarget) {
        focusTarget.focus();
      }
    }
  }, [animationState, isNavPanelOpen]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('sb-hamburgerNav bg-white', {
      pt5: !isSecondaryNavPanel,
      'flex flex-column justify-between': animationState !== _useAnimationState.states.closed && hasNavFooter,
      hidden: animationState === _useAnimationState.states.closed,
      block: animationState === _useAnimationState.states.open,
      'sb-hamburgerNav--opening block': animationState === _useAnimationState.states.opening,
      'sb-hamburgerNav--closing block': animationState === _useAnimationState.states.closing
    }),
    id: isSecondaryNavPanel ? "secondary-hamburger-nav-panel-".concat(secondaryNavPanelName) : PRIMARY_HAMBURGER_PANEL_ID
  }, children);
};
NavPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  hasNavFooter: _propTypes["default"].bool,
  isNavPanelOpen: _propTypes["default"].bool,
  isSecondaryNavPanel: _propTypes["default"].bool,
  returnFocusElement: _propTypes["default"].object
} : {};
var _default = exports["default"] = NavPanel;